export enum Functionality {
  URZADZENIA_GLC = 'URZADZENIA_GLC',
  HARMONOGRAMY = 'HARMONOGRAMY',
  KARTY_POSIADACZE = 'KARTY_POSIADACZE',
  SEKWENCJA = 'SEKWENCJA',
  POSZUKIWANY = 'POSZUKIWANY',
  KONTROLA = 'KONTROLA',
  ZDARZENIA = 'ZDARZENIA',
  ZDARZENIA_INNE = 'ZDARZENIA_INNE',
  UPR_GRUPOWE = 'UPR_GRUPOWE',
  UPR_INDYWIDUALNE = 'UPR_INDYWIDUALNE',
  KOMUNIKAT = 'KOMUNIKAT',
  DEFINICJE = 'DEFINICJE',
  UZYTKOWNICY = 'UZYTKOWNICY',
  HISTORIA = 'HISTORIA',
  ARCHIWUM = 'ARCHIWUM',
  LICENCJA = 'LICENCJA',
  ZESTAWIENIE_UPRAWNIEN = 'ZESTAWIENIE_UPRAWNIEN',
  RAPORT_WYDANYCH_KART = 'RAPORT_WYDANYCH_KART',
  RAPORT_POSIADACZY_BEZ_ZDARZEN = 'RAPORT_POSIADACZY_BEZ_ZDARZEN',
  RAPORT_ZDARZEN = 'RAPORT_ZDARZEN',
  RAPORT_ZDARZEN_INNE = 'RAPORT_ZDARZEN_INNE',
  RAPORT_CZASU_OBECNOSCI = 'RAPORT_CZASU_OBECNOSCI',
  OBECNOSCI = 'OBECNOSCI',
  RAPORT_OSOB_OBECNYCH = 'RAPORT_OSOB_OBECNYCH',
}
